<template>

  <SubHeading :home="home" :tabs="tabs" :shorts="false" :currTab="currTab" color="red lighten-3" @active="handleActive" />

  <!-- breadcrumbs -->
  <nav class="sba-collection-breadcrumb auth-add-breadcrumb z-depth-0">
    <div class="container nav-wrapper">
      <div class="sba-collection-breadcrumb-row">
        <router-link to="/" class="breadcrumb sba-collection-crumb teal-text">
          <i class="material-icons">home</i>
          <span>Dashboard</span>
        </router-link>
        <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
        <router-link to="/auth" class="breadcrumb sba-collection-crumb teal-text">
          <span>Authorization Home</span>
        </router-link>
        <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
        <span class="breadcrumb sba-collection-crumb blue-grey-text">
          <span>Add Auth</span>
        </span>
        <span class="sba-collection-context">Pre-Authorization Workspace</span>
      </div>
    </div>
  </nav>

  <!-- Top -->
  <div id="top"></div>

  <div class="container auth-add-page-shell">
    <div class="auth-add-workbench sba-slide-in" :key="enrollee ? 'auth-add-detail' : 'auth-add-start'">
      <div class="auth-add-super-card">
        <button type="button" class="secondary-page-back" title="Back to Authorization Home" @click.prevent="handleActive(home)">
          <i class="material-icons">keyboard_return</i>
        </button>
        <div class="auth-add-super-copy">
          <button type="button" class="secondary-parent-link" @click.prevent="handleActive(home)">Authorization Home</button>
          <small>Back to Auth list</small>
        </div>
      </div>

      <div class="auth-add-head">
        <div class="auth-add-title-block">
          <label class="active teal-text">Authorization Desk</label>
          <h5>Add Authorization</h5>
          <p>Identify the enrollee, confirm the scheme, and prepare a new authorization request.</p>
        </div>
      </div>
  
      <div class="auth-add-body-surface">
        <LoadingDiv v-if="!isReady" />

        <template v-else>
          <EnrolleeAuth @restart="handleRestart" :enrollee="enrollee" :serverDate="serverDate" v-if="enrollee" />
          <StartAuth @next="handleNext" v-else />
        </template>
      </div>
    </div>
  </div>
</template>


<script>
import { ref, onMounted, onBeforeUnmount, nextTick } from "vue";
import useModuleNavigation from "@/composables/useModuleNavigation";
import SubHeading from "@/components/HeaderSubDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import StartAuth from "@/components/auth/StartAuthComponent.vue";
import EnrolleeAuth from "@/components/auth/EnrolleeAuthComponent.vue";

export default {
  name: "authAdd",
  components: { SubHeading, LoadingDiv, StartAuth, EnrolleeAuth },
  setup() {
    const back = ref("auth"); // default
    const isReady = ref(true);
    const enrollee = ref(null);
    const serverDate = ref(null);
    const home = ref(null);
    const currTab = ref(null);
    const tabs = ref([]);

    const { routeToTab } = useModuleNavigation();

    // start
    onMounted(() => {
      // page name
      document.title = "Add Authorization";
      document.documentElement.classList.add("auth-add-active");
      nextTick(() => window.scrollTo({ top: 0, behavior: "auto" }));
    });

    onBeforeUnmount(() => {
      document.documentElement.classList.remove("auth-add-active");
    });

    // menu
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Pre-Auth", title: "All", icon: "arrow_back", url: "auth", hash: null, });
      tabs.value.push({ id: 2, name: "Pre-Auth", title: "Add Auth", icon: null, url: "authAdd", hash: null, });

      // set default
      currTab.value = tabs.value.find(x => x.title.includes("Add"));
      // set home
      home.value = tabs.value.find(x => x.url === "auth");
    });

    const scrollToPageTop = () => {
      nextTick(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    };

    // handle curr status
    const handleActive = (tab) => {
      if (!tab) {
        return;
      }

      if (tab.url === "authAdd") {
        handleRestart();
        document.title = "Add Authorization";
        scrollToPageTop();
        routeToTab(tab, { replace: true, scroll: false });
        return;
      }

      if (tab.url === "auth") {
        handleRestart();
        routeToTab(tab);
        return;
      }

      routeToTab(tab);
    };

    // // handle back
    // const handleBack = () => {
    //   if (back.value == "auth") {
    //     router.push({ name: "auth" }); // final back
    //   } else if (back.value == "authAdd") {
    //     handleRestart(); // restart auth
    //   } else {
    //     router.push({ name: "home" }); // safeguard to prevent unexpected errors
    //   }
    // };

    // handle next
    const handleNext = (val) => {
      enrollee.value = val.value;
      serverDate.value = val.serverDate;
      back.value = "authAdd";
    };

    // handle restart
    const handleRestart = () => {
      enrollee.value = null;
      serverDate.value = null;
      back.value = "auth";
      scrollToPageTop();
    };


    return {
      handleActive,
      home,
      serverDate,
      currTab,
      tabs,
      handleNext,
      handleRestart,
      isReady,
      enrollee,
    };
  },
};
</script>

<style scoped>
/* Keep this route content-sized without changing other workspace pages. */
:global(html.auth-add-active),
:global(html.auth-add-active body),
:global(html.auth-add-active #app),
:global(html.auth-add-active .app-shell main) {
  height: auto !important;
  min-height: 0 !important;
}

:global(html.auth-add-active .app-shell) {
  height: auto !important;
  min-height: 100vh !important;
}

.auth-add-breadcrumb {
  background: #fafafa !important;
  position: relative;
}

.auth-add-breadcrumb::after {
  background: #c4d3d9;
  bottom: 0;
  content: "";
  height: 1px;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
}

.auth-add-page-shell {
  margin-top: -14px;
  overflow: visible;
  padding-bottom: 44px;
  padding-top: 0;
  position: relative;
  z-index: 1;
}

.auth-add-workbench {
  color: #263238;
}

.auth-add-super-card,
.auth-add-head,
.auth-add-body-surface,
.auth-add-workbench :deep(.auth-start-card),
.auth-add-workbench :deep(.auth-start-search-card),
.auth-add-workbench :deep(.auth-start-result-card),
.auth-add-workbench :deep(.auth-enrollee-card),
.auth-add-workbench :deep(.auth-provider-workflow),
.auth-add-workbench :deep(.auth-provider-summary),
.auth-add-workbench :deep(.auth-provider-panel),
.auth-add-workbench :deep(.auth-diagnosis-card),
.auth-add-workbench :deep(.auth-claims-card),
.auth-add-workbench :deep(.auth-history-shell),
.auth-add-workbench :deep(.auth-no-encounter) {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.auth-add-super-card {
  align-items: center;
  background: #fff8e1;
  border: 1px solid #c4d3d9;
  border-bottom: 0;
  border-radius: 6px 6px 0 0;
  box-shadow: 0 10px 20px -24px rgba(121, 85, 72, 0.55);
  display: flex;
  gap: 10px;
  min-height: 46px;
  padding: 10px 14px;
  position: relative;
  width: 100%;
  z-index: 3;
}

.auth-add-head {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 0;
  box-shadow: 0 12px 20px -18px rgba(38, 50, 56, 0.55);
  margin-bottom: 0;
  padding: 24px 26px;
  position: relative;
  z-index: 2;
}

.auth-add-body-surface {
  background: transparent;
  border: 0;
  border-radius: 0 0 6px 6px;
  box-shadow: none;
  overflow: visible;
  padding: 0;
  position: relative;
  z-index: 5;
}

.auth-add-head::before {
  border: 1px solid #c4d3d9;
  border-bottom: 0;
  border-radius: 0 7px 0 0;
  content: "";
  height: 18px;
  left: -1px;
  pointer-events: none;
  position: absolute;
  right: -1px;
  top: -1px;
  z-index: 1;
}

.auth-add-title-block {
  position: relative;
  z-index: 2;
}

.secondary-page-back {
  align-items: center;
  background: #00897b;
  border: 1px solid #00796b;
  border-radius: 5px;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  height: 28px;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 28px;
}

.secondary-page-back:hover {
  background: #00695c;
}

.secondary-page-back i {
  color: #ffffff;
  font-size: 17px;
  line-height: 17px;
}

.auth-add-super-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.15;
}

.secondary-parent-link {
  background: transparent;
  border: none;
  border-radius: 4px;
  color: #4e342e;
  cursor: pointer;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 800;
  margin: 0;
  padding: 0;
  text-align: left;
  text-transform: uppercase;
  transition: background-color 0.18s ease, color 0.18s ease;
}

.secondary-parent-link:hover {
  color: #00897b;
}

.auth-add-super-copy small {
  color: #6d4c41;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: none;
}

.auth-add-title-block h5 {
  color: #263238;
  font-weight: 700;
  margin: 4px 0 0;
}

.auth-add-title-block p {
  color: #607d8b;
  line-height: 1.45;
  margin: 6px 0 0;
  max-width: 760px;
}

@media only screen and (max-width: 700px) {
  .auth-add-page-shell {
    margin-top: -12px;
    padding-bottom: 34px;
  }

  .auth-add-super-card {
    align-items: flex-start;
  }

  .auth-add-head {
    padding: 22px;
  }

  .auth-add-title-block h5 {
    font-size: 1.45rem;
  }

  .auth-add-title-block p {
    font-size: 0.94rem;
  }

  .auth-add-workbench :deep(.auth-start-card),
  .auth-add-workbench :deep(.auth-start-search-card),
  .auth-add-workbench :deep(.auth-start-result-card),
  .auth-add-workbench :deep(.auth-enrollee-card),
  .auth-add-workbench :deep(.auth-provider-workflow),
  .auth-add-workbench :deep(.auth-provider-summary),
  .auth-add-workbench :deep(.auth-provider-panel),
  .auth-add-workbench :deep(.auth-diagnosis-card),
  .auth-add-workbench :deep(.auth-claims-card),
  .auth-add-workbench :deep(.auth-history-shell),
  .auth-add-workbench :deep(.auth-no-encounter) {
    border-radius: 8px;
  }

  .auth-add-workbench :deep(.card-content),
  .auth-add-workbench :deep(.card-panel) {
    padding: 16px;
  }

  .auth-add-workbench :deep(.btn),
  .auth-add-workbench :deep(.btn-large),
  .auth-add-workbench :deep(button) {
    min-height: 40px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .auth-add-super-card,
  .auth-add-head,
  .auth-add-body-surface,
  .auth-add-workbench :deep(.auth-start-card),
  .auth-add-workbench :deep(.auth-start-search-card),
  .auth-add-workbench :deep(.auth-start-result-card),
  .auth-add-workbench :deep(.auth-enrollee-card),
  .auth-add-workbench :deep(.auth-provider-workflow),
  .auth-add-workbench :deep(.auth-provider-summary),
  .auth-add-workbench :deep(.auth-provider-panel),
  .auth-add-workbench :deep(.auth-diagnosis-card),
  .auth-add-workbench :deep(.auth-claims-card),
  .auth-add-workbench :deep(.auth-history-shell),
  .auth-add-workbench :deep(.auth-no-encounter) {
    animation: none;
  }
}
</style>
